import axios from 'axios';
import authHeader from '@/services/auth.header';
import { HTTP } from '@/http/config'; 
import { AnyObject } from 'yup';
const API_URL = HTTP.api_url;
class FormaPagoService {
    async getIndex():Promise<AnyObject>{    
        const response = await axios.get(API_URL + 'formapagos', { headers: authHeader() })
         .then(response => {        
           //console.log(JSON.stringify(response.data.data))
           return response.data;
         }).catch(error => {
           const dataError = JSON.stringify(error.response.data)
           console.log(dataError)      
         });
         return  response;
        }  
    async getSearch(search):Promise<AnyObject>{    
          const response = await axios.get(API_URL + `formapagos`, 
          { 
            params: search,
            headers: authHeader() 
          })
           .then(response => {        
             //console.log(JSON.stringify(response.data.data))
             return response.data;
           }).catch(error => {
             const dataError = JSON.stringify(error.response.data)
             console.log(dataError)      
           });
           return  response;
          }  
    async getlist(pageNumber):Promise<AnyObject>{    
        const response = await axios.get(API_URL + `formapagos?page=${pageNumber}`, { headers: authHeader() })
         .then(response => {        
           //console.log(JSON.stringify(response.data.data))
           return response.data;
         }).catch(error => {
           const dataError = JSON.stringify(error.response.data)
           console.log(dataError)      
         });
         return  response;
        } 

        async postCreated(formapagos):Promise<AnyObject> {    
            const response = await axios.post(API_URL + 'formapagos', 
               formapagos, 
              { headers: authHeader() }
            )
            .then(response =>{
             // console.log(response.data)
              return response.data;
            })
            .catch(error=>{
              const dataError = error.response.data
              console.log(dataError)   
              return dataError;
            });
            return response;
          }
   
          async postUpdate(id,formapagos):Promise<AnyObject> {    
             const response = await axios.put(API_URL + `formapagos/${id}`,  
               {id:Number(id),...formapagos},     
               { headers: authHeader() },      
             )
             .then(response =>{
               //console.log(response.data)
               return response?.data;
             })
             .catch(error=>{
               const dataError = error.response.data
               console.log(dataError)   
               return dataError;
             });
             return response;
           }
           async getEdit(id):Promise<AnyObject[]>{
            const response = await axios.get(API_URL + `formapagos/${id}`,     
             { headers: authHeader() }
           )
           .then(response =>{     
             return response?.data;
           })
           .catch(error=>{
             const dataError = error.response.data
             console.log(dataError)   
             return dataError;
           });
           return response;
         }
       
          async getDelete(id):Promise<AnyObject>{
            const response = await axios.delete(API_URL + `formapagos/${id}`,     
             { headers: authHeader() }
           )
           .then(response =>{      
             return response?.data;
           })
           .catch(error=>{
             const dataError = error.response.data
             console.log(dataError)   
             return dataError;
           });
           return response;
         }

        async getListFormaPago():Promise<AnyObject>{    
        const response = await axios.get(API_URL + 'formapagos/list-fpagos', { headers: authHeader() })
         .then(response => {        
           //console.log(JSON.stringify(response.data.data))
           return response.data.data;
         }).catch(error => {
           const dataError = JSON.stringify(error.response.data)
           console.log(dataError)      
         });
         return  response;
        }  


}
export default new FormaPagoService()